import React, { useState } from 'react'
import { SendMessageForm } from '~/src/components/molecules/Form/SendMessageForm'
import { IPostRequestOrderMessageRequestBody } from '~/src/repositories/Order/models/Order'
import { useMultipleFileUpload } from '~/src/hooks/useMultipleFileUpload'
import { Box, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface IMessageFormProps {
  onSubmit: (value: IPostRequestOrderMessageRequestBody) => void
  isPosting: boolean
}

/**
 * MessageForm
 * @param onSubmit
 * @param isPosting
 * @constructor
 */
export const MessageForm: React.FC<IMessageFormProps> = ({ onSubmit, isPosting }): JSX.Element => {
  const [message, setMessage] = React.useState<string>('')
  const [isLoading, setIsLoading] = useState(false)
  const { filesToUpload, setFilesToUpload, handleFileChange, handleFileDelete, putFileUpload } =
    useMultipleFileUpload()

  /**
   * handleChange
   * @param event
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(event.target.value)
  }
  /**
   * handleSubmit
   * @param e
   */
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formValue: IPostRequestOrderMessageRequestBody = {
      message: message,
    }
    setIsLoading(true)
    // upload file
    const uploadFileList = await putFileUpload(filesToUpload)

    if (uploadFileList && uploadFileList.length > 0) {
      formValue['files'] = uploadFileList
    }

    onSubmit(formValue)
    setFilesToUpload([])
    setIsLoading(false)
    setMessage('')
  }
  /**
   * handleDeleteFile
   * @param selectedFile {File}
   */
  const handleDeleteFile = (selectedFile: File) => {
    handleFileDelete(selectedFile)
  }

  /**
   * uploadFile
   * multiple file upload
   * @param e
   */
  function uploadFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files) {
      handleFileChange(e.target.files)
    }
  }

  return (
    <>
      <SendMessageForm
        message={message}
        filesToUpload={filesToUpload}
        isLoading={isLoading}
        isPosting={isPosting}
        handleSubmit={handleSubmit}
        handleChangeMessage={handleChange}
        uploadFile={uploadFile}
        setFilesToUpload={setFilesToUpload}
      />
      <Box ml={3} mb={2}>
        {filesToUpload.map((file, index: number) => {
          return (
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={index}>
              <Typography sx={{ marginRight: '4px' }}>{file.name}</Typography>
              <IconButton
                sx={{
                  background: '#D4D4D4',
                  width: '24px',
                  height: '24px',
                }}
                onClick={() => handleDeleteFile(file)}
              >
                <CloseIcon
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
              </IconButton>
            </Box>
          )
        })}
      </Box>
    </>
  )
}
